
<template>
  <button class="btn custom" :class="{'btn-size': size}" 
    @click.prevent="getClickEvent" :data-icon="icon" :data-position="pos"
    :id="buttonID" :data-text="myText">    
  </button>
</template>

<script>

export default {
  props: ['id', 'myText', 'icon', 'pos', 'size'],
  data: function () {
    return {
      buttonID: ''
    }
  },
  created: function () {
    this.buttonID = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
  },
  mounted: function () {

    let myButton = document.getElementById(this.buttonID);
    let data = myButton.dataset.text;
    let arr = data.split("");
    let node, node2 = document.createElement('span'); 

    if (this.pos == 'right') {
      arr.forEach((item) => {
        let node = document.createElement('span');
        let textNode = document.createTextNode(item);
        node.appendChild(textNode);            
        myButton.appendChild(node);
      });

      node2.setAttribute('class', 'right-icon fa fa-' + myButton.dataset.icon);
      myButton.appendChild(node2);             

    } else if (this.pos == 'left') {
      node2.setAttribute('class', 'left-icon fa fa-' + myButton.dataset.icon);
      myButton.appendChild(node2);             

      arr.forEach((item) => {
        let node = document.createElement('span');
        let textNode = document.createTextNode(item);
        node.appendChild(textNode);            
        myButton.appendChild(node);
      });
    }
  },
  methods: {
    getClickEvent: function () {
      this.$emit('clicked');
    }
  }
}
</script>

<style lang="scss">

@import "../../../src/assets/css/variables";

.btn-size {
  width: 20% !important;
}

button span {
  white-space: pre;
}

button, .btn, a.btn {

  .right-icon {
    margin-left: .5em;
  }
  .left-icon {
    margin-right: .5em;
  }      

  $interval: 0.045;

  @for $i from 1 through 21 {
    &:hover > span:nth-child(#{$i}) {
      -webkit-transition-delay: $interval + s;
      transition-delay: $interval + s;        
    }

    $interval: $interval + 0.038;
  }
} 

</style>







// WEBPACK FOOTER //
// src/components/shared/CustomButton.vue